import React, { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  label: string;
}

export const Arrow: FunctionComponent<IProps> = ({ label }) => {
  return (
    <View style={styles.container}>
      <View style={[styles.arrowHead, { borderBottomColor: Theme.PRIMARY }]} />
      <View style={[styles.arrowBody, { backgroundColor: Theme.PRIMARY }]} />
      <Text style={styles.text}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
  arrowHead: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderLeftWidth: defaultScale(5),
    borderRightWidth: defaultScale(5),
    borderBottomWidth: defaultScale(10),
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
  },
  arrowBody: {
    height: defaultScale(30),
    width: defaultScale(2),
  },
  text: {
    ...Theme.textStyle.bodyCopyReg,
  },
});
